export const staircaseConfig = {
    gameSlug: 'digit-span-backward',
    category: 'eau_memoire',
    variable: 'n_items',
    startValue: 3,
    minValue: 2,
    maxValue: 9,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    // MVP : 24 essais max (< 5 min test live).
    maxTrials: 24,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, itemDurationMs: 1100, label: 'Tempo posé' };
    }
    if (level <= 20) {
        return { level, itemDurationMs: 900, label: 'Tempo standard' };
    }
    if (level <= 30) {
        return { level, itemDurationMs: 750, label: 'Tempo soutenu' };
    }
    if (level <= 40) {
        return { level, itemDurationMs: 650, label: 'Tempo rapide' };
    }
    return { level, itemDurationMs: 550, label: 'Limite exécutive' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase (fixation, pre-sequence, gap, feedback, ITI). */
export const timing = {
    fixationMs: 400,
    preSequenceMs: 600,
    gapMs: 200,
    feedbackMs: 700,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'digit-span-backward',
    paradigm: 'Digit Span Backward (WAIS-IV WMS, Wechsler 2008)',
    category: 'eau_memoire',
    goal: 'Mémoire de travail verbale : retenir et inverser une séquence en tête.',
};
//# sourceMappingURL=params.js.map